export const getElementById = (id: string) => {
  try {
    return document.getElementById(id)
  }
  catch (error) {
    console.error(error)
    return null
  }
}
